"use client"

import React, { useRef } from "react"
import { Modal, Button, Form } from "@douyinfe/semi-ui"
import type { FormApi } from '@douyinfe/semi-ui/lib/es/form/interface';
import { useModal } from "./Provdier"
import { useLogin } from "@/hooks/useUser"
import toast from 'react-hot-toast';
import './index.css'

export default function Login() {
  const { isLoginOpen, setIsLoginOpen, setIsRegisterOpen } = useModal()
  const { login, loginLoading } = useLogin();
  const formApiRef = useRef<FormApi<{ userName: string, password: string }>>(null)

  function handleSubmit() {
    formApiRef.current?.validate().then((values) => {
      login(values).then(() => {
        setIsLoginOpen(false)
        toast.success('登录成功')
      }).catch((err) => {
        toast.error(err?.msg || err?.message || '登录失败')
      })
    })
  }

  function FooterComponent() {
    return (
      <div className="w-full flex justify-star flex-col">
        <Button loading={loginLoading} theme="solid" className="bg-black!" block size="large" style={{ marginLeft: 0 }} type="primary" onClick={handleSubmit} >立即登录</Button>
        <div className="text-sm text-gray-500 mx-auto pt-4">没有账号？<span className="text-blue-500 cursor-pointer" onClick={() => {
          setIsLoginOpen(false)
          setIsRegisterOpen(true)
        }}>立即注册</span></div>
      </div>
    )
  }

  function LoginForm() {
    return (
      <Form
        autoComplete="off"
        getFormApi={(formApi) => formApiRef.current = formApi}
        className="pb-10"
      >
        <Form.Input
          autoComplete="off"
          trigger='blur'
          rules={[
            { required: true, message: '请输入手机号' },
            { validator: (rule, value) => value?.length === 11, message: '请填写正确的手机号' }
          ]}
          field='userName'
          label='手机号'
          style={{ width: '100%' }}
          size="large"
          placeholder='请输入手机号'
        ></Form.Input>
        <Form.Input
          autoComplete="off"
          rules={[
            { required: true, message: '请输入密码' },
          ]}
          field='password'
          mode="password"
          label='密码'
          style={{ width: '100%' }}
          size="large"
          placeholder='请输入密码'
        ></Form.Input>
      </Form>
    )
  }

  return (
    <>
      <Modal footer={FooterComponent()} title="登录" visible={isLoginOpen} hasCancel={false} onCancel={() => setIsLoginOpen(false)} closeOnEsc={false} maskClosable={false} modalContentClass="!w-[90%] mx-auto sm:!w-[440px]">
        <LoginForm />
      </Modal>
    </>
  )
}
